/**
 * Runs started by tests, probes and experiments stay out of the real view (ADR 0059 decision 4):
 * an agent whose Orgus home is a test home (`.orgus-dev/homes/<name>`, AGENTS.md) or that runs
 * with ORGUS_TEST_RUNS=1 marks every session it launches `Session.ext.testRun`, and the Sessions
 * page lists those only under its Tests filter. Both agents mirror isTestHome. Browser-safe.
 */
import type { Session } from '../index.ts';

/** The key under Session.ext: true for a run a test, probe or experiment started. */
export const SESSION_TEST_RUN_EXT = 'testRun';

/** Set to 1 on an agent whose launches are all test runs, whatever its home. */
export const TEST_RUNS_ENV = 'ORGUS_TEST_RUNS';

/** A test home: an Orgus home under `.orgus-dev/homes/` (any repo, any slash). */
export function isTestHome(home: string | null | undefined): boolean {
  if (!home) return false;
  return /(?:^|\/)\.orgus-dev\/homes\/[^/]+/i.test(home.split('\\').join('/'));
}

/** Whether an agent's launches are test runs: its home is a test home, or ORGUS_TEST_RUNS is 1. */
export function launchesAreTestRuns(home: string | null | undefined, envValue: string | null | undefined): boolean {
  return envValue === '1' || isTestHome(home);
}

/** A session a test, probe or experiment started. */
export function isTestRun(s: Partial<Pick<Session, 'ext'>> | null | undefined): boolean {
  return s?.ext?.[SESSION_TEST_RUN_EXT] === true;
}
